// This file is generated from analytics-schema.yaml. Do not edit it by hand.

export const ANALYTICS_EVENTS = {
  carestate: {
    patientNoteSaved: 'carestate.patient.note_saved',
    problemNoteSaved: 'carestate.problem.note_saved',
    requestNoteSaved: 'carestate.request.note_saved',
    requestStatusChanged: 'carestate.request.status_changed',
    requestUrgencyChanged: 'carestate.request.urgency_changed',
    scopeChanged: 'carestate.scope.changed',
  },
  copilot: {
    appLoaded: 'copilot.app.loaded',
    chatToolCallReceived: 'copilot.chat.toolCall.received',
    chatUserMessageSent: 'copilot.chat.userMessage.send',
    panelTabChanged: 'copilot.panel.tab_changed',
    proposedActionAlternativeSwitched: 'copilot.proposedAction.alternative_switched',
    proposedActionApproved: 'copilot.proposedAction.approved',
    proposedActionExecuted: 'copilot.proposedAction.executed',
    proposedActionRejected: 'copilot.proposedAction.rejected',
    proposedActionRevisionStarted: 'copilot.proposedAction.revision_started',
    toolOutcome: 'copilot.tool.outcome',
  },
  internalNote: {
    created: 'internal_note.created',
  },
  labs: {
    orderSubmitAttempted: 'labs.order.submit_attempted',
    orderSubmitResult: 'labs.order.submit_result',
    testCreateResult: 'labs.test.create_result',
    wizardModeSelected: 'labs.wizard.mode_selected',
    wizardOpened: 'labs.wizard.opened',
    wizardStepViewed: 'labs.wizard.step_viewed',
  },
  navigator: {
    patientSelected: 'navigator.patient.selected',
    searchChanged: 'navigator.search.changed',
  },
  overlay: {
    tabFocused: 'overlay.tab.focused',
  },
  rx: {
    prescriptionCancelAttempted: 'rx.prescription.cancel_attempted',
    prescriptionCancelDialogOpened: 'rx.prescription.cancel_dialog_opened',
    prescriptionCancelResult: 'rx.prescription.cancel_result',
    prescriptionLogsOpened: 'rx.prescription.logs_opened',
    prescriptionsViewed: 'rx.prescriptions.viewed',
    refillApproveAttempted: 'rx.refill.approve_attempted',
    refillApproveResult: 'rx.refill.approve_result',
    submitAttempted: 'rx.submit_attempted',
    submitResult: 'rx.submit_result',
    wizardOpened: 'rx.wizard.opened',
    wizardStepViewed: 'rx.wizard.step_viewed',
  },
  session: {
    authenticated: 'session.authenticated',
    unauthenticated: 'session.unauthenticated',
  },
  workspace: {
    patientClosed: 'workspace.patient.closed',
    patientOpened: 'workspace.patient.opened',
    tabFocused: 'workspace.tab.focused',
    visibilityChanged: 'workspace.visibility.changed',
  },
} as const;

export type ActorT = 'clinician' | 'copilot';
export type ScopeTypeT = 'patient' | 'problem' | 'request';

export type AnalyticsCommonProperties = Readonly<{
  actor: 'clinician' | 'copilot';
  appEnv: string;
  clinicianDisplayName?: string;
  clinicianUserId?: string;
  patientUserId?: string;
  scopeType?: 'patient' | 'problem' | 'request';
  workspaceSessionId?: string;
}>;

export type AnalyticsEventMap = Readonly<{
  'carestate.patient.note_saved': Readonly<{
    noteDeltaLength?: number;
    noteLength: number;
  }>;
  'carestate.problem.note_saved': Readonly<{
    noteDeltaLength?: number;
    noteLength: number;
    problemId: string;
  }>;
  'carestate.request.note_saved': Readonly<{
    noteDeltaLength?: number;
    noteLength: number;
    requestId: string;
  }>;
  'carestate.request.status_changed': Readonly<{
    newStatus: 'Open' | 'Resolved' | 'Cancelled';
    oldStatus: 'Open' | 'Resolved' | 'Cancelled';
    requestAgeMs?: number;
    requestId: string;
  }>;
  'carestate.request.urgency_changed': Readonly<{
    newUrgency: 'Routine' | 'Urgent';
    oldUrgency: 'Routine' | 'Urgent';
    requestId: string;
  }>;
  'carestate.scope.changed': Readonly<{
    fromScopeType?: 'patient' | 'problem' | 'request';
    toScopeType: 'patient' | 'problem' | 'request';
  }>;
  'copilot.app.loaded': Record<string, never>;
  'copilot.chat.toolCall.received': Readonly<{
    inputType: string;
    tool: string;
    toolCallId: string;
  }>;
  'copilot.chat.userMessage.send': Readonly<{
    source: string;
    textLength: number;
    userId: string;
  }>;
  'copilot.panel.tab_changed': Readonly<{
    fromTabId?: string;
    tabId: string;
  }>;
  'copilot.proposedAction.alternative_switched': Readonly<{
    alternativePayloadId: string;
    externalId: string;
    label: string;
    toolName: string;
  }>;
  'copilot.proposedAction.approved': Readonly<{
    autoExecuted: boolean;
    externalId: string;
    label: string;
    toolName: string;
  }>;
  'copilot.proposedAction.executed': Readonly<{
    externalId: string;
    label: string;
    toolName: string;
  }>;
  'copilot.proposedAction.rejected': Readonly<{
    externalId: string;
    hasReason: boolean;
    label: string;
    toolName: string;
  }>;
  'copilot.proposedAction.revision_started': Readonly<{
    externalId: string;
    hasReason: boolean;
    label: string;
    toolName: string;
  }>;
  'copilot.tool.outcome': Readonly<{
    durationMs?: number;
    outcome: 'success' | 'failure';
    toolCallId: string;
    toolName: string;
  }>;
  'internal_note.created': Readonly<{
    linkType: 'patient' | 'problem' | 'request';
    noteLength: number;
  }>;
  'labs.order.submit_attempted': Readonly<{
    aoeAnswerCount: number;
    hasNotes: boolean;
    mode: 'existing_test' | 'custom_test' | 'native_order_set';
    notesLength?: number;
    prioritySet: boolean;
  }>;
  'labs.order.submit_result': Readonly<{
    mode: 'existing_test' | 'custom_test' | 'native_order_set';
    outcome: 'success' | 'failure';
  }>;
  'labs.test.create_result': Readonly<{
    outcome: 'success' | 'failure';
  }>;
  'labs.wizard.mode_selected': Readonly<{
    mode: 'existing_test' | 'custom_test';
  }>;
  'labs.wizard.opened': Record<string, never>;
  'labs.wizard.step_viewed': Readonly<{
    stepId: 'select-test' | 'custom-test' | 'disease-codes' | 'review' | 'confirmation';
  }>;
  'navigator.patient.selected': Readonly<{
    routineCount?: number;
    selectedPatientUserId: string;
    unreadCount?: number;
    urgentCount?: number;
  }>;
  'navigator.search.changed': Readonly<{
    queryLength: number;
  }>;
  'overlay.tab.focused': Readonly<{
    fromTabId?: string;
    tabId: string;
  }>;
  'rx.prescription.cancel_attempted': Readonly<{
    dosespotPrescriptionId: string;
  }>;
  'rx.prescription.cancel_dialog_opened': Readonly<{
    prescriptionIdPresent: boolean;
  }>;
  'rx.prescription.cancel_result': Readonly<{
    dosespotPrescriptionId: string;
    outcome: 'success' | 'rejected' | 'error';
  }>;
  'rx.prescription.logs_opened': Readonly<{
    prescriptionIdPresent: boolean;
  }>;
  'rx.prescriptions.viewed': Readonly<{
    count: number;
  }>;
  'rx.refill.approve_attempted': Readonly<{
    refillId: number;
  }>;
  'rx.refill.approve_result': Readonly<{
    outcome: 'success' | 'failure';
    refillId: number;
  }>;
  'rx.submit_attempted': Readonly<{
    hasPharmacyNotes: boolean;
    kind: 'coded' | 'compound';
    noSubstitutions: boolean;
  }>;
  'rx.submit_result': Readonly<{
    kind: 'coded' | 'compound';
    outcome: 'success' | 'failure';
  }>;
  'rx.wizard.opened': Record<string, never>;
  'rx.wizard.step_viewed': Readonly<{
    stepId: 'kind' | 'details' | 'patient' | 'allergies' | 'review' | 'confirmation';
  }>;
  'session.authenticated': Readonly<{
    hasPhoneNumber: boolean;
    isAnonymous: boolean;
  }>;
  'session.unauthenticated': Record<string, never>;
  'workspace.patient.closed': Readonly<{
    durationMs: number;
  }>;
  'workspace.patient.opened': Record<string, never>;
  'workspace.tab.focused': Readonly<{
    fromTabId?: string;
    tabId: string;
  }>;
  'workspace.visibility.changed': Readonly<{
    visibility: 'visible' | 'hidden';
  }>;
}>;

export type AnalyticsEventName = keyof AnalyticsEventMap;
